
export class DialogAlignment {
    static center = 'center';
    static top = 'top';
    static bottom = 'bottom';
  }
  